import { MenuItemType } from "@/core/types/contentTypes";
import {
  HeaderNavigationItem,
  SecondaryNavigationItem,
  IssuesListItem,
  SettingsDropdownNavItem,
  SearchNavigationItem,
  PostsListNavigationItem,
} from "@/types/layout";
import { DIGI_SUBS_PRICE_VALUE, subsURL } from "@/constants/reporter";

//TODO: Only dummy data
export const dummySecondaryNavLinks: HeaderNavigationItem[] = [
  {
    title: "Výběr editora",
    linkPath: "#editors-pick",
  },
  {
    title: "Audio",
    linkPath: "#audio",
  },
  {
    title: "Aktuální vydání",
    linkPath: "#issue-section",
  },
  {
    title: "Autoři",
    linkPath: "#latest-authors",
  },
  {
    title: "Krátké čtení",
    linkPath: "/",
  },
];

export const secondaryNavigationLinks: SecondaryNavigationItem[] = [
  {
    title: "Předplatné",
    url: subsURL.ALL_SUBS_URL,
    badge_content: `od ${DIGI_SUBS_PRICE_VALUE} Kč`,
  },
  // {
  //   title: "Obchod",
  //   url: "#",
  // },
];

export const settingsDropdownLinks: SettingsDropdownNavItem[] = [
  {
    title: "Nastavení",
    icon_path: "/assets/images/icons/arrow-down.svg",
    url: "#",
  },
];

export const postsByLengthNavigationLinks: PostsListNavigationItem[] = [
  {
    name: "Krátké čtení",
    link: "/delka/kratke",
  },
  {
    name: "Středně dlouhé čtení",
    link: "/delka/stredni",
  },
  {
    name: "Dlouhé čtení",
    link: "/delka/dlouhe",
  },
];

export const exploreNavigationLinks: SearchNavigationItem[] = [
  {
    title: "Prezidentské volby",
    url: "#",
    iconPath: "/assets/images/icons/chevron-right.svg",
    priorityIconPath: "/assets/images/icons/star.svg",
  },
  {
    title: "Andrej Babiš",
    url: "#",
    iconPath: "/assets/images/icons/chevron-right.svg",
    priorityIconPath: "/assets/images/icons/star.svg",
  },
  {
    title: "Magazín",
    url: "#",
    iconPath: "/assets/images/icons/chevron-right.svg",
  },
];

//TODO: remove after API implementation
export const IssuesListLinks: IssuesListItem[] = [
  {
    title: "Prosinec 2022",
    number_of_journal: "Číslo 100",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Listopad 2022",
    number_of_journal: "Číslo 99",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Říjen 2022",
    number_of_journal: "Číslo 98",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Říjen 2022",
    number_of_journal: "Číslo 98",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Prosinec 2022",
    number_of_journal: "Číslo 100",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Listopad 2022",
    number_of_journal: "Číslo 99",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Říjen 2022",
    number_of_journal: "Číslo 98",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
  {
    title: "Říjen 2022",
    number_of_journal: "Číslo 98",
    image_path: "/assets/images/issue/1.png",
    url: "#",
  },
];

//TODO: remove after API implementation
// TODO: may need to add the path to the active icon
export const fixedNavbarLinks: MenuItemType[] = [
  {
    id: 1,
    url: "",
    parent: 0,
    children: [],
    promoted: false,
    iconHover: false,
    title: "Sdílet",
    icon: "/assets/images/icons/new-share.svg",
  },
  {
    id: 2,
    url: "",
    parent: 0,
    children: [],
    promoted: false,
    iconHover: false,
    title: "Odemknout",
    icon: "/assets/images/icons/new-unlock.svg",
  },
  {
    id: 3,
    url: "",
    parent: 0,
    children: [],
    promoted: false,
    iconHover: false,
    title: "Uložit",
    icon: "/assets/images/icons/homepage-bookmark.svg",
  },
];
